import type { ReactNode } from 'react';
import { Loader2, PenLine } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  ESIGN_DISCLOSURE_BODY,
  ESIGN_DISCLOSURE_CONSENT_LABEL,
  ESIGN_DISCLOSURE_TITLE,
} from '@/lib/esign-disclosure';
import './contract-document.css';

export function ContractSignConfirm({
  note,
  testId = 'contract-sign-confirm',
  includeDisclosure = true,
  checkboxId,
  accepted,
  onAccepted,
  label = ESIGN_DISCLOSURE_CONSENT_LABEL,
  primaryLabel,
  primaryDisabled,
  primaryPending,
  onPrimary,
  secondary,
}: {
  note?: string;
  testId?: string;
  includeDisclosure?: boolean;
  checkboxId: string;
  accepted: boolean;
  onAccepted: (next: boolean) => void;
  label?: string;
  primaryLabel: string;
  primaryDisabled?: boolean;
  primaryPending?: boolean;
  onPrimary: () => void;
  secondary?: ReactNode;
}) {
  return (
    <div className="cd-sign-confirm" data-testid={testId}>
      {note ? <p className="cd-sig-note">{note}</p> : null}
      {includeDisclosure ? (
        <div className="cd-esign">
          <p className="cd-esign-title">{ESIGN_DISCLOSURE_TITLE}</p>
          <p className="cd-esign-body">{ESIGN_DISCLOSURE_BODY}</p>
        </div>
      ) : null}
      <label className="cd-check" htmlFor={checkboxId}>
        <Checkbox
          id={checkboxId}
          checked={accepted}
          onCheckedChange={(checked) => onAccepted(checked === true)}
        />
        <span>{label}</span>
      </label>
      <div className="cd-sign-actions">
        {secondary}
        <Button onClick={onPrimary} disabled={primaryDisabled || primaryPending}>
          {primaryPending ? (
            <Loader2 className="h-4 w-4 animate-spin mr-1.5" />
          ) : (
            <PenLine className="h-4 w-4 mr-1.5" />
          )}
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
}
